import { render, staticRenderFns } from "./cases-table.vue?vue&type=template&id=43b1e47c&"
import script from "./cases-table.vue?vue&type=script&lang=js&"
export * from "./cases-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VDataTable,VIcon,VSkeletonLoader})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43b1e47c')) {
      api.createRecord('43b1e47c', component.options)
    } else {
      api.reload('43b1e47c', component.options)
    }
    module.hot.accept("./cases-table.vue?vue&type=template&id=43b1e47c&", function () {
      api.rerender('43b1e47c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CasesPage/components/cases-table.vue"
export default component.exports